import React from 'react';
import { Dotted } from '../icons';

interface Props {
  color?: string;
}

const DottedListIcon: React.FC<Props> = ({ color }) => <Dotted width={3} height={3} color={color} />;

export default DottedListIcon;
